import Store from 'store'

export default function onTransitionendCallback(methods, options = {}) {
    const statePropName = methods.statePropName ?? 'page_overlay_open'
    const parent = methods.parent ?? document
    const store = Store
    const DOM = parent.querySelector('.kb-page-overlay__cover')
    const persistent = options.persistent ?? false

    const handler = () => {
        if (store.state.main[statePropName])
            methods && typeof methods.opening === 'function'
                ? methods.opening()
                : false
        if (!store.state.main[statePropName])
            methods && typeof methods.closing === 'function'
                ? methods.closing()
                : false

        if (!persistent) DOM.removeEventListener('transitionend', handler)
    }

    if (DOM) {
        DOM.addEventListener('transitionend', handler)
    } else {
        console.warn(
            'PageOverlay: DOM element not found (kb-page-overlay__cover)'
        )
    }
}
